import React, { useEffect, useMemo, useState } from 'react';
import { Button, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../../Common/DataTable';
import { GeneratePDFInBoxListingInterface } from '../utils/types';
import ComponentSendEmailModel from './ComponentSendEmailModel';
import { getCustomerContactList, resetEmailFlag } from '../../oilReport/redux/oilReportSlice';
import { RootState } from '../../../redux/rootState';
import { setLoader } from '../../../redux/loaderSlice';

function ComponentPDFinBox() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  // const [page, setPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedContacts, setSelectedContacts] = useState<string[]>([]);
  const { custId } = useParams();
  // const [data, setData] = useState<GeneratePDFInBoxListingInterface[]>([]);
  const {
    CustomerContactList, isContactLoading, isJOFlagAdded, isMailSentLoading,
  } = useSelector((state: RootState) => state.oilReportReducer);
  const { isLoading } = useSelector((state: RootState) => state.reportWorkspaceReducer);
  const [emailsData, setEmailsData] = useState('');

  const columns = useMemo(
    () => [
      { key: 'actionSn', label: '' },
      { key: 'Name', label: 'Name' },
      { key: 'Address', label: 'Email Address' },
      { key: 'EC_Report', label: 'EC Report' },
      { key: 'Oil_Report', label: 'Oil Report' },
    ],
    [],
  );

  const clearSelectedContacts = () => {
    setSelectedContacts([]);
  };

  useEffect(() => {
    if (isJOFlagAdded) {
      dispatch(resetEmailFlag());
      navigate(-1);
    }
  }, [isJOFlagAdded]);

  const tableData: GeneratePDFInBoxListingInterface[] = useMemo(() => {
    if (CustomerContactList?.Data?.length > 0) {
      const transformedData = CustomerContactList?.Data?.map((ele, index) => ({
        actionSn: index,
        Name: `${ele.FirstName} ${ele?.LastName}`,
        Address: ele.Email,
        EC_Report: ele.EctReport ? 'Yes' : 'No',
        Oil_Report: ele.OilReport ? 'Yes' : 'No',
        id: `${String(ele.ContactId)}`,
        // id: `${String(ele.Email)}`,
        isChecked: selectedContacts?.includes(String(ele.ContactId)),
      }));
      return transformedData;
    }
    return [];
  }, [CustomerContactList, selectedContacts]);

  // useEffect(() => {
  //   if (CustomerContactList) {
  //     setData(tableData);
  //   }
  // }, [CustomerContactList]);

  const handleButtonClick = () => {
    const jobIds: string[] = [];
    tableData?.forEach((element) => {
      if (element?.isChecked && element?.Address?.length > 0) {
        jobIds.push(element?.Address);
      }
    });
    const payload = {
      selectedIds: jobIds,
    };
    const emailString = payload.selectedIds.join(', ');
    setEmailsData(emailString);
    setOpen(true);
  };

  const handleData = () => {
    const payload = {
      customerId: custId, searchQuery,
    };
    dispatch(getCustomerContactList(payload));
  };

  useEffect(() => {
    handleData();
  }, []);

  const handleCheckBoxWithKey = (id: string) => {
    if (selectedContacts?.includes(id)) {
      setSelectedContacts(selectedContacts?.filter((item) => item !== id));
    } else {
      setSelectedContacts([...selectedContacts, id]);
    }
    // const updatedData = data?.map((element: GeneratePDFInBoxListingInterface) => {
    //   if (element?.id === id) {
    //     return {
    //       ...element,
    //       isChecked: !element?.isChecked,
    //     };
    //   }
    //   return element;
    // });
    // setData(updatedData);
  };

  useEffect(() => {
    if (isLoading || isContactLoading || isMailSentLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
  }, [isContactLoading, isLoading, isMailSentLoading]);

  const jobSelected = useMemo(() => tableData?.every((ele) => !ele?.isChecked), [tableData]);

  return (
    <>
      <ComponentPageHeader subHeading={`Contacts of ${CustomerContactList?.Data?.[0]?.CustomerName}`} />
      <div style={{ padding: '20px', height: '86vh', overflow: 'auto' }}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <DataTable<GeneratePDFInBoxListingInterface>
              data={tableData}
              columns={columns}
              totalRecords={CustomerContactList.TotalRecords}
              // page={page}
              // setPage={setPage}
              // rowsPerPage={rowsPerPage}
              // setRowsPerPage={setRowsPerPage}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              checkBoxWithKey={['actionSn']}
              handleCheckBoxWithKey={handleCheckBoxWithKey}
              handleData={handleData}
            />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <div className="save_and_next_div" style={{ marginTop: '20px' }}>
              <div className="button_margin_left">
                <Button
                  type="button"
                  disabled={jobSelected}
                  onClick={() => handleButtonClick()}
                  className="button_save_and_next"
                >
                  Proceed
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
        { open && (
          <ComponentSendEmailModel
            show={open}
            setOpenFrom={() => setOpen(false)}
            emailsData={emailsData}
            handleClear={clearSelectedContacts}
          />
        )}
      </div>
    </>
  );
}

export default ComponentPDFinBox;
